import { inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { Observable } from 'rxjs';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
} from '@shared/components/widgets/dialog/confirmation/confirmation-dialog.component';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  private readonly dialog = inject(Dialog);

  openConfirmationDialog(dialogConfig?: Partial<ConfirmationDialogData>): Observable<boolean> {
    const dialogRef = this.dialog.open<boolean>(ConfirmationDialogComponent, {
      data: { ...dialogConfig },
      ...TsDialogComponent.getDefaultDialogConfig(),
    });

    return dialogRef.closed;
  }

  static deleteConfirmationCommonLayoutConfig(): Partial<ConfirmationDialogData> {
    return {
      description: 'This action is not reversible',
      renderHtml: false,
      buttonsConfig: {
        yes: 'Delete',
        no: 'Cancel',
      },
    };
  }

  static unsavedChangesCommonLayoutConfig(): Partial<ConfirmationDialogData> {
    return {
      dialogTitle: 'Discard Changes?',
      description: 'Changes haven’t been saved. Do you wish to discard the changes?',
      renderHtml: false,
      buttonsConfig: {
        yes: 'Discard',
        no: 'No',
      },
    };
  }

  static updateGeoCodeCommonLayoutConfig(): Partial<ConfirmationDialogData> {
    return {
      dialogTitle: 'Update Address Location?',
      description: 'Would you like to update the address location?',
      buttonsConfig: {
        yes: 'Update',
        no: 'Skip',
      },
    };
  }
}
